/**
 * Error handling utilities for control plane client
 */

/**
 * Type definition for AWS SDK error structure
 */
type AwsServiceError = {
  name?: string;
  code?: string;
  message?: string;
  $response?: {
    headers?: Record<string, string>;
  };
};

/**
 * Checks if an error is related to token expiration
 * @param error - Error to check (can be any type of error)
 * @returns boolean indicating whether error is due to token expiration
 */
export const isTokenExpirationError = (error: unknown): boolean => {
  // Handle standard Error objects
  if (error instanceof Error) {
    return (
      error.name === 'TokenExpirationException' || error.message.toLowerCase().includes('expired')
    );
  }

  // Handle AWS SDK specific error objects
  if (typeof error === 'object' && error !== null) {
    const awsError = error as AwsServiceError;

    return Boolean(
      // Check common token expiration indicators
      awsError.name === 'TokenExpirationException' ||
        awsError.code === 'ExpiredTokenException' ||
        awsError.message?.toLowerCase()?.includes('expired') ||
        awsError.$response?.headers?.['x-amzn-errortype']?.includes('ExpiredToken'),
    );
  }

  // For any other type of error (string, number, etc.), it's not a token expiration
  return false;
};
